class SizeGuideTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.querySelector("button");

    if (!this.button) return;

    this.button.addEventListener("mouseenter", () => {
      this._getData();
    });

    this.button.addEventListener("click", () => {
      this._openModal(this.button);
    });
  }

  disconnectedCallback() {}

  _openModal(sourceElement) {
    const detail = { target: "size-guide-modal", html: this._getData() };
    (sourceElement || this).dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail,
      }),
    );
  }

  _getData() {
    const url = new URL(`${window.location.origin}${this.url}`);
    url.searchParams.set("section_id", this.sectionId);

    if (url.toString() === this.lastUrl) {
      if (this._data) return Promise.resolve(this._parseData(this._data));
      if (this.loadingData) return this.loadingData;
    }

    this.lastUrl = url.toString();

    this.loadingData = fetch(url)
      .then((res) => res.text())
      .then((data) => {
        this._data = data;

        return this._parseData(data);
      });

    return this.loadingData;
  }

  _parseData(data) {
    const section = new DOMParser().parseFromString(data, "text/html");
    const targetEl = document
      .createRange()
      .createContextualFragment(section.querySelector("body").innerHTML);

    return targetEl;
  }

  get url() {
    return this.getAttribute("url");
  }

  get sectionId() {
    return this.getAttribute("section-id") || "size-guide";
  }
}

if (!customElements.get("size-guide-trigger")) {
  customElements.define("size-guide-trigger", SizeGuideTrigger);
}

// Intercept #size-guide anchor clicks — open modal without updating the URL hash
if (!window.__sizeGuideClickListenerAdded) {
  window.__sizeGuideClickListenerAdded = true;
  document.addEventListener("click", (e) => {
    const link = e.target.closest('a[href="#size-guide"]');
    if (!link) return;
    e.preventDefault();

    const trigger = document.querySelector("size-guide-trigger");
    if (trigger) trigger._openModal(link);
  });
}

// Open on page load when the URL already contains #size-guide
if (window.location.hash === "#size-guide") {
  requestAnimationFrame(() => {
    const trigger = document.querySelector("size-guide-trigger");
    if (trigger) trigger._openModal();
  });
}
